import { HelpCircle, LayoutAlt01, LogOut01, MedicalCircle, MessageSquare01, UserCircle } from '@aktiia/design-system';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { FetchStatus, ModalName } from '../../../../../enums';
import { useAccount } from '../../../../../features/account';
import { useAuth, useLogout, useResetLogoutStatus } from '../../../../../features/auth';
import { useOpenModal } from '../../../../../features/modals';
import { isAdmin } from '../../../../../utils';
import { Logo } from '../../../../common';
import { NavbarItem } from './components';

export const Navbar = () => {
  const { t } = useTranslation();
  const {
    status: { logout: logoutStatus },
  } = useAuth();
  const { account } = useAccount();
  const logout = useLogout();
  const resetLogoutStatus = useResetLogoutStatus();
  const openContactSupportModal = useOpenModal(ModalName.CONTACT_SUPPORT);
  const openSendFeedbackModal = useOpenModal(ModalName.SEND_FEEDBACK);
  const navigate = useNavigate();

  useEffect(() => {
    if (logoutStatus === FetchStatus.SUCCESS) {
      resetLogoutStatus();
      navigate('/login');
    }
  }, [logoutStatus]);

  return (
    <nav className="w-[240px] h-full fixed flex flex-col border-r border-border-divider bg-background-base-primary z-40">
      <Link to="/" className="px-6 py-3 border-b border-border-divider">
        <Logo />
      </Link>
      <div className="h-full flex flex-col py-6">
        <NavbarItem text={t('common.menu.patients')} path="/app/patients" icon={<LayoutAlt01 />} />
        <NavbarItem
          text={t('common.menu.organization')}
          path={`/app/organization${isAdmin(account) ? '' : '/details'}`}
          icon={<MedicalCircle />}
        />
        <NavbarItem text={t('common.menu.profile')} path="/app/profile" icon={<UserCircle />} />
        <div className="grow" />
        <NavbarItem text={t('common.menu.help')} icon={<HelpCircle />} onClick={() => openContactSupportModal()} />
        <NavbarItem
          text={t('common.menu.feedback')}
          icon={<MessageSquare01 />}
          onClick={() => openSendFeedbackModal()}
        />
        <NavbarItem text={t('common.menu.logout')} icon={<LogOut01 />} onClick={logout} />
      </div>
    </nav>
  );
};
